import React from 'react'
import MainContentSimCard from './MainContentSimCard'


const LayoutSimCard = () => {
  return (
    <div className='page-sim-card'>
      <MainContentSimCard />
    </div>
  )
}

export default LayoutSimCard 
